/*
this snippet is an extension of dtc-rebuy-horizonal-scroller
which makes Rebuy Smart Cart Template display products horizonal
this script changes the title of the snippet to display none
when a recommended product widget is hidden
*/

const applyRebuyAccessibility = () => {
  // Fix "Powered by Rebuy" link accessibility
  document.querySelectorAll('.powered-by-rebuy a').forEach((link) => {
    if (!link.dataset.a11yPatched) {
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('aria-label', 'Powered by Rebuy (opens in a new tab)');

      // Add visually hidden text for screen readers indicating new tab
      if (!link.querySelector('.sr-only')) {
        const srText = document.createElement('span');
        srText.className = 'sr-only';
        srText.textContent = ' (opens in a new tab)';
        link.appendChild(srText);
      }

      link.dataset.a11yPatched = 'true';
    }
  });
};

const handleRebuyCartUpdate = () => {
  setTimeout(() => {
    const parentElement = document.querySelector('.dtc-rebuy-horizontal');
    const horizontalSmartCartTitle = document.querySelector('#dtc-rebuy-horizontal-title');

    if (parentElement) {
      const rebuyWidgets = parentElement.querySelectorAll('.rebuy-widget');
      if (rebuyWidgets.length > 0) {
        let allWidgetsHaveIsHiddenClass = true;

        rebuyWidgets.forEach((widget) => {
          let widgetTitle = widget.querySelector('.primary-title');
          let productInfo = widget.querySelector('.rebuy-product-info');
          let dtc_rebuy_primary_title = widget.querySelector('.dtc-rebuy-primary-title');
          if (widgetTitle && productInfo) {
            if (dtc_rebuy_primary_title === null) {
              let spanElement = document.createElement('div');
              spanElement.classList.add('dtc-rebuy-primary-title');
              spanElement.textContent = widgetTitle.textContent;
              productInfo.prepend(spanElement);
            }
          }

          if (!widget.classList.contains('is-hidden')) {
            allWidgetsHaveIsHiddenClass = false;
          }
        });

        if (horizontalSmartCartTitle) {
          horizontalSmartCartTitle.style.display = allWidgetsHaveIsHiddenClass ? 'none' : 'block';
        }
      }
    }

    applyRebuyAccessibility();
  }, 1000);
};

['rebuy:cart.change', 'rebuy:cart.open', 'rebuy:ready'].forEach((eventName) => {
  document.addEventListener(eventName, handleRebuyCartUpdate);
});